export default __webpack_public_path__ + "static/media/icon-print-circle-solid.950c1461.svg";